import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import React, { useState } from 'react';

import Popover from '~/App/Components/Popover';
import { DropdownPanel } from '~/App/Components/DropdownPanel';

const StyledDropdownPanel = styled(DropdownPanel)`
  border: 1px transparent;
`;

function Compact({ children, popoverBody, place = 'below', ...props }) {
  const [isOpen, setOpen] = useState(false);

  function openPopover() {
    setOpen(true);
  }

  function closePopover() {
    setOpen(false);
  }

  function getRenderProps() {
    return {
      openPopover,
      closePopover,
      state: {
        isOpen,
      },
      togglePopover: isOpen ? closePopover : openPopover,
    };
  }

  function getPopoverProps() {
    return {
      isOpen,
      place,
      components: {
        BodyContainer: StyledDropdownPanel,
      },
      onOuterAction: closePopover,
      body: popoverBody(getRenderProps()),
      ...props,
    };
  }

  return <Popover {...getPopoverProps()}>{children(getRenderProps())}</Popover>;
}

Compact.propTypes = {
  children: PropTypes.func.isRequired,
  popoverBody: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.func,
    PropTypes.string,
  ]).isRequired,
  align: PropTypes.oneOf(['left', 'right', 'middle']),
  place: PropTypes.oneOf(['above', 'right', 'below', 'left']),
};

export default Compact;
